<template>
	<Popup
		v-model="selfDisplay"
		title="新增商户"
		confirmBtnText="新增"
		@confirmClick="handleAddClick"
	>
		<div v-loading="loading" style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商户号</span>
				<el-input v-model="number" placeholder="商户号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="numberTip"><i class="b_icon"></i>请输入商户号</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>姓名</span>
				<el-input v-model="name" placeholder="姓名"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="nameTip"><i class="b_icon"></i>请输入姓名</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>手机号</span>
				<el-input v-model="mobile" placeholder="手机号"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="mobileTip"><i class="b_icon"></i>请输入11位合法手机号</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>省市区</span>
				<VDistpicker :province="addr.provinceName" :city="addr.cityName" :area="addr.areaName" @province="handleProvinceSelect" @city="handleCitySelect" @area="handleAreaSelect"></VDistpicker>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addrTip"><i class="b_icon"></i>请选择省市区</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>详细地址</span>
				<el-input v-model="detailAddr" placeholder="详细地址"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="detailAddrTip"><i class="b_icon"></i>请输入详细地址</template></div>
			
			<div class="base_form_row">
				<span class="b_label">经度</span>
				<el-input v-model="lng" placeholder="经度"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="lngTip"><i class="b_icon"></i>经度整数部分为0-180,小数部分为0到6位</template></div>
			
			<div class="base_form_row">
				<span class="b_label">纬度</span>
				<el-input v-model="lat" placeholder="纬度"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="latTip"><i class="b_icon"></i>纬度整数部分为0-90,小数部分为0到6位</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>性别</span>
				<el-select v-model="sex" placeholder="请选择" style="width: 100%;">
					<el-option :value="0" label="男"></el-option>
					<el-option :value="1" label="女"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>商务经理</span>
				<el-select v-model="manager" filterable placeholder="请选择" style="width: 100%;">
					<el-option v-for="v in appManager" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="managerTip"><i class="b_icon"></i>请选择商务经理</template></div>
			
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>折扣</span>
				<el-input v-model="sale" placeholder="折扣"></el-input>
			</div>
			<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="saleTip"><i class="b_icon"></i>请输入100以内整数</template></div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	import Api from '../../../../../../../api/index.js';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean
		},
		data () {
			return {
				loading: false,
				selfDisplay: false,
				number: '',
				name: '',
				mobile: '',
				addr: {
					provinceName: '',
					provinceCode: '',
					cityName: '',
					cityCode: '',
					areaName: '',
					areaCode: ''
				},
				detailAddr: '',
				lng: '',
				lat: '',
				sex: 0,
				manager: '',
				sale: '',
				numberTip: false,
				nameTip: false,
				mobileTip: false,
				addrTip: false,
				detailAddrTip: false,
				lngTip: false,
				latTip: false,
				managerTip: false,
				saleTip: false
			}
		},
		computed: {
			...mapState([
				'authInfo',
				'appManager'
			])
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		methods: {
			// 省份选择
			handleProvinceSelect(data) {
				this.addr.provinceName = data.code ? data.value : '';
				this.addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 城市选择
			handleCitySelect(data) {
				this.addr.cityName = data.code ? data.value : '';
				this.addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 区域选择
			handleAreaSelect(data) {
				this.addr.areaName = data.code ? data.value : '';
				this.addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击新增
			handleAddClick() {
				if (!this.number.trim()) {
					this.numberTip = true;
					return false;
				} else {
					this.numberTip = false;
				}
				if (!this.name.trim()) {
					this.nameTip = true;
					return false;
				} else {
					this.nametTip = false;
				}
				if (!this.phoneReg.test(this.mobile)) {
					this.mobileTip = true;
					return false;
				} else {
					this.mobileTip = false;
				}
				if (!this.addr.areaCode) {
					this.addrTip = true;
					return false;
				} else {
					this.addrTip = false;
				}
				if (!this.detailAddr.trim()) {
					this.detailAddrTip = true;
					return false;
				} else {
					this.detailAddrTip = false;
				}
				if (this.lng) {
					if (!this.lngReg.test(this.lng)) {
						this.lngTip = true;
						return false;
					} else {
						this.lngTip = false;
					}
				} else {
					this.lngTip = false;
				}
				if (this.lat) {
					if (!this.latReg.test(this.lat)) {
						this.latTip = true;
						return false;
					} else {
						this.latTip = false;
					}
				} else {
					this.latTip = false;
				}
				if (!this.manager) {
					this.managerTip = true;
					return false;
				} else {
					this.managerTip = false;
				}
				if (!/^(?:0|[1-9][0-9]?|100)$/.test(this.sale)) {
					this.saleTip = true;
					return false;
				} else {
					this.saleTip = false;
				}
				this.add();
			},
			// 新增商户
			add() {
				const that = this;
				that.loading = true;
				let requestData = {
					commCode: that.number,
					commUserName: that.name,
					userPhone: that.mobile,
					bUserId: that.manager,
					uProvinceCode: that.addr.provinceCode,
					uCityCode: that.addr.cityCode,
					uAreaCode: that.addr.areaCode,
					locationDetail: that.detailAddr,
					commPercent: that.sale,
					longitude: that.lng,
					latitude: that.lat,
					userSex: that.sex
				};
				Api.addAppMerchant(requestData).then((res) => {
					if (res.data.success) {
						that.loading = false;
						that.$message.success(res.data.message);
						that.selfDisplay = false;
						that.$emit('onSuccess');
					} else {
						that.loading = false;
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (!newVal) {
					this.loading = false;
					this.number = '';
					this.name = '';
					this.mobile = '';
					this.addr = {
						provinceName: this.authInfo.uprovinceName || '',
						provinceCode: this.authInfo.uprovinceCode || '',
						cityName: this.authInfo.ucityName || '',
						cityCode: this.authInfo.ucityCode || '',
						areaName: this.authInfo.uareaName || '',
						areaCode: this.authInfo.uareaCode || ''
					};
					this.detailAddr = '';
					this.lng = '';
					this.lat = '';
					this.sex = 0;
					this.manager = '';
					this.sale = '';
					this.numberTip = false;
					this.nameTip = false;
					this.mobileTip = false;
					this.addrTip = false;
					this.detailAddrTip = false;
					this.lngTip = false;
					this.latTip = false;
					this.managerTip = false;
					this.saleTip = false;
				}
			}
		}
	}
</script>

<style>
</style>
